import { getVideoCompName, getVideoElementRef } from 'organisms/MarketingHero/AU/MarketingUtilities/marketingUtils';
import React, { useState } from 'react';

const VideoComponent = props => {
  const { srcFile, defaultPath = '', nameSuffix = '', formatType = '', ...rest } = props;

  const [shouldRetry, setShouldRetry] = useState(true);

  const errorHandler = event => {
    event.target.onerror = null;

    if (shouldRetry) {
      event.target.src = defaultPath;
    }

    setShouldRetry(false);
  };

  // When SRC File is empty then No Need to render the Video tag Itself
  // autoPlay='autoPlay'
  return srcFile !== '' && srcFile !== null && srcFile !== undefined ? (
    <video
      id={getVideoCompName(nameSuffix)}
      onError={errorHandler}
      className='videoComp'
      {...rest}
      src={srcFile}
      type={formatType || ''}
      muted
      playsInline
    />
  ) : null;
};

export const getAllVideoElementRef = () => {
  return document.querySelectorAll('*[id^="videoComp"]');
};

export const play = nameSuffix => {
  getVideoElementRef(nameSuffix)?.play();
};

export const pause = nameSuffix => {
  getVideoElementRef(nameSuffix)?.pause();
};

export const pauseAll = () => {
  getAllVideoElementRef().forEach(element => element?.pause());
};

export const showControl = (show, nameSuffix) => {
  if (getVideoElementRef(nameSuffix)) {
    getVideoElementRef(nameSuffix).control = show;
  }
};

export const mute = (muteParam, nameSuffix) => {
  if (getVideoElementRef(nameSuffix)) {
    getVideoElementRef(nameSuffix).muted = muteParam;
  }
};

export const playFrom = (playFromParam, nameSuffix) => {
  if (getVideoElementRef(nameSuffix)) {
    getVideoElementRef(nameSuffix).currentTime = playFromParam;
    play(nameSuffix);
  }
};

// default export
export default VideoComponent;
